/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InvestmentFundViewModel } from './InvestmentFundViewModel';
import {
    InvestmentFundViewModelFromJSON,
    InvestmentFundViewModelFromJSONTyped,
    InvestmentFundViewModelToJSON,
} from './InvestmentFundViewModel';

/**
 * 
 * @export
 * @interface InvestmentComponentViewModel
 */
export interface InvestmentComponentViewModel {
    /**
     * 
     * @type {string}
     * @memberof InvestmentComponentViewModel
     */
    componentName: string;
    /**
     * 
     * @type {number}
     * @memberof InvestmentComponentViewModel
     */
    allocation: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentComponentViewModel
     */
    marketValue: number;
    /**
     * 
     * @type {Array<InvestmentFundViewModel>}
     * @memberof InvestmentComponentViewModel
     */
    funds: Array<InvestmentFundViewModel>;
}

/**
 * Check if a given object implements the InvestmentComponentViewModel interface.
 */
export function instanceOfInvestmentComponentViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "componentName" in value;
    isInstance = isInstance && "allocation" in value;
    isInstance = isInstance && "marketValue" in value;
    isInstance = isInstance && "funds" in value;

    return isInstance;
}

export function InvestmentComponentViewModelFromJSON(json: any): InvestmentComponentViewModel {
    return InvestmentComponentViewModelFromJSONTyped(json, false);
}

export function InvestmentComponentViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentComponentViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'componentName': json['ComponentName'],
        'allocation': json['Allocation'],
        'marketValue': json['MarketValue'],
        'funds': ((json['Funds'] as Array<any>).map(InvestmentFundViewModelFromJSON)),
    };
}

export function InvestmentComponentViewModelToJSON(value?: InvestmentComponentViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ComponentName': value.componentName,
        'Allocation': value.allocation,
        'MarketValue': value.marketValue,
        'Funds': ((value.funds as Array<any>).map(InvestmentFundViewModelToJSON)),
    };
}

